<dx-select-box
  class="pictured-item-select-box"
  [label]="label"
  [searchEnabled]="true"
  [searchExpr]="'name'"
  [value]="value"
  (valueChange)="valueChange.emit($event)"
  [items]="items"
  valueExpr="name"
  stylingMode="filled"
  labelMode="hidden"
  width="100%"
  fieldTemplate="field"
  [dropDownOptions]="{
    wrapperAttr: { class: 'pictured-item-select-box-dropdown' }
  }"
>
  <div *dxTemplate="let data of 'field'" class="pictured-item-select-field">
    <img
      [alt]="data.name"
      class="pictured-item-image"
      src="data:image/svg+xml;base64,{{ data.image }}"
    />
    <dx-text-box
      [hoverStateEnabled]="false"
      [inputAttr]="{ class: 'pictured-item-editor-input' }"
      [readOnly]="false"
      [value]="data.name"
    >
    </dx-text-box>
  </div>
  <div *dxTemplate="let data of 'item'">
    <img
      [alt]="data.name"
      class="pictured-item-image"
      height="20px"
      src="data:image/svg+xml;base64,{{ data.image }}"
    />
   <small> {{ data.name }} </small>
  </div>
</dx-select-box>